export default {
  title: 'E-Time',
  home: 'Home',
  company: 'Company',
  'company-table': require('./CompanyTable.js').default
}
